"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.promise");
require("core-js/modules/es7.promise.finally");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.iterator");
require("core-js/modules/es6.object.to-string");
require("core-js/modules/es6.object.keys");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const Input_1 = require("@components/atoms/Input");
const _layouts_1 = require("@layouts");
const _utils_1 = require("@utils"); // ContentfulDestination
var ContactPage = function ContactPage() {
    var _React$useState = react_1.default.useState(""), firstName = _React$useState[0], setFirstName = _React$useState[1];
    var _React$useState2 = react_1.default.useState(""), lastName = _React$useState2[0], setLastName = _React$useState2[1];
    var _React$useState3 = react_1.default.useState(""), email = _React$useState3[0], setEmail = _React$useState3[1];
    var _React$useState4 = react_1.default.useState(""), phone = _React$useState4[0], setPhone = _React$useState4[1];
    var _React$useState5 = react_1.default.useState(""), inquiryType = _React$useState5[0], setInquiryType = _React$useState5[1];
    var _React$useState6 = react_1.default.useState(""), message = _React$useState6[0], setMessage = _React$useState6[1];
    var _React$useState7 = react_1.default.useState(false), submitting = _React$useState7[0], setSubmitting = _React$useState7[1];
    var formEnabled = function formEnabled() {
        var pass = true;
        [firstName, lastName, email, phone, message].map(function (val) {
            if (pass)
                pass = val !== "";
        });
        return !!pass;
    };
    var encode = function encode(data) {
        return Object.keys(data).map(function (key) {
            return encodeURIComponent(key) + "=" + encodeURIComponent(data[key]);
        }).join("&");
    };
    var submitMessage = function submitMessage(e) {
        e.preventDefault();
        setSubmitting(true);
        fetch('/', {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: encode({
                "form-name": "contact",
                firstName: firstName,
                lastName: lastName,
                email: email,
                phone: phone,
                message: message
            })
        }).then(function () {
            return window.location.assign('/thanks');
        }).catch(function (error) {
            return console.log(error);
        }).finally(function () {
            return setSubmitting(false);
        });
    };
    return /*#__PURE__*/ react_1.default.createElement(_layouts_1.NavLayout, null, /*#__PURE__*/ react_1.default.createElement("div", {
        className: "layoutBorder"
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.SectionHeader, {
        title: "Contact",
        small: true,
        ruleBottom: true,
        fullWidth: true,
        halfPadding: true
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.LayoutRow, {
        label: "Phone Number:",
        value: "+1(212) 619 0352",
        href: "tel://12126190352"
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.LayoutRow, {
        label: "General Inquiries:",
        value: "hello@prior.club",
        href: "mailto:hello@prior.club?subject=PRIOR - General Inquiry"
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.LayoutRow, {
        label: "Membership Inquiries:",
        value: "membership@prior.club",
        href: "mailto:membership@prior.club?subject=PRIOR - Membership Inquiry"
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.LayoutRow, {
        label: "Studio Inquiries:",
        value: "studio@prior.club",
        href: "mailto:studio@prior.club?subject=PRIOR - Studio Inquiry"
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.LayoutRow, {
        label: "Press Inquiries:",
        value: "press@prior.club",
        href: "mailto:press@prior.club?subject=PRIOR - Press Inquiry"
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.LayoutRow, {
        label: "Address:",
        value: "PRIOR, 262 Bowery, Floor 5, New York, NY 10012",
        href: "https://www.google.com/maps/place/262+Bowery+Floor+5,+New+York,+NY+10012/data=!4m2!3m1!1s0x89c25985bfd52237:0x5d4da6716523fd1b?sa=X&ved=2ahUKEwj93pSMgefpAhXImOAKHY8ECbgQ8gEwAHoECAsQAQ",
        target: "_blank",
        rel: "noopener"
    })), /*#__PURE__*/ react_1.default.createElement("div", {
        className: "layoutBorder"
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.LayoutRule, null), /*#__PURE__*/ react_1.default.createElement(atoms_1.LayoutSubtitle, {
        title: "To learn more about PRIOR, fill out the details of your request below.",
        alignLeft: true
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.Padding, {
        halfPadding: true
    }, /*#__PURE__*/ react_1.default.createElement(Form, {
        id: "contactForm",
        name: "contact",
        method: "POST",
        onSubmit: function onSubmit(e) {
            return submitMessage(e);
        },
        "data-netlify": "true",
        "data-netlify-honeypot": "bot-field"
    }, /*#__PURE__*/ react_1.default.createElement("input", {
        type: "hidden",
        name: "form-name",
        value: "contact"
    }), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, {
        split: true
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        name: "firstName",
        value: firstName,
        label: "First Name",
        onChange: function onChange(e) {
            return setFirstName(e.target.value);
        },
        required: true,
        disabled: submitting
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        name: "lastName",
        value: lastName,
        label: "Last Name",
        onChange: function onChange(_ref) {
            var value = _ref.target.value;
            return setLastName(value);
        },
        required: true,
        disabled: submitting
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "email",
        name: "email",
        value: email,
        label: "Email Address",
        onChange: function onChange(_ref2) {
            var value = _ref2.target.value;
            return setEmail(value);
        },
        required: true,
        disabled: submitting
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "tel",
        name: "phone",
        value: phone,
        label: "Phone Number",
        onChange: setPhone,
        disabled: submitting
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "select",
        name: "inquiryType",
        value: inquiryType,
        label: "Inquiry Type",
        onChange: function onChange(_ref3) {
            var value = _ref3.target.value;
            return setInquiryType(value);
        },
        options: ['General', 'Studio', 'Membership', 'Press'],
        emptyFirstOption: true,
        disabled: submitting
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "textarea",
        name: "message",
        value: message,
        label: "Your message\u2026",
        onChange: function onChange(_ref4) {
            var value = _ref4.target.value;
            return setMessage(value);
        },
        required: true,
        disabled: submitting
    })), /*#__PURE__*/ react_1.default.createElement(ButtonWrapper, null, !submitting && /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, {
        type: "black",
        size: "large",
        display: "flex",
        disabled: !formEnabled,
        onClick: function onClick() { }
    }, !submitting && /*#__PURE__*/ react_1.default.createElement("span", null, "Send Inquiry"), submitting && /*#__PURE__*/ react_1.default.createElement("span", null, "Submitting\u2026")))))));
}; // Styling
var Form = styled_components_1.default.form.withConfig({
    displayName: "contact__Form",
    componentId: "lv5xmf-0"
})([""]);
var ButtonWrapper = styled_components_1.default.div.withConfig({
    displayName: "contact__ButtonWrapper",
    componentId: "lv5xmf-1"
})(["padding-top:8px;", "{padding-top:16px;}"], _utils_1.mediaQuery('desktop'));
exports.default = ContactPage;
